<div id="standard-modal" role="dialog" aria-labelledby="standard-modalLabel">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title" id="standard-modalLabel">{{ (isNew ? 'category.add.titleAdd' : 'category.add.titleAlter') | translate }}</h4>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true" (click)="close()"></button>
    </div>

    <div class="modal-body">
      <form [formGroup]="formGroup">
        <div class="mb-3">
          <label class="form-label fw-semibold text-dark">{{ 'category.add.nameLabel' | translate }}</label>
          <input type="text" class="form-control" formControlName="name" [placeholder]="'category.add.namePlaceholder' | translate" />
          <field-error-component [field]="'name'" [label]="'category.add.nameFieldLabel' | translate" [formGroup]="formGroup" />
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="close()">
        {{ 'category.add.cancel' | translate }}
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        [mat-dialog-close]="true"
        [disabled]="!formGroup.valid"
        (click)="save()"
      >
        {{ (isNew ? 'category.add.save' : 'category.add.alter') | translate }}
        @if (loading) {
          <mat-spinner
            [diameter]="25"
            [color]="'accent'"
            mode="indeterminate"
          />
        }
      </button>
    </div>
  </div>
</div>